export default "__VITE_PUBLIC_ASSET__f3829d1a__"